var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"summary-row",class:{
    'summary-row-error':_vm.showStatus && _vm.creationStatus === 'error',
    'summary-row-deleted':_vm.showStatus && _vm.creationStatus === 'deleted',
    'summary-row-creating':_vm.showStatus && _vm.creationStatus === 'creating',
    'summary-row-success':_vm.showStatus && _vm.creationStatus && _vm.creationStatus !== 'error',
  }},[_c('b-col',{staticClass:"summary-row-text",attrs:{"cols":"8"}},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('b-col',{attrs:{"cols":"4"}},[(_vm.status && _vm.showStatus)?_c('template-status',{attrs:{"status":_vm.status}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }